import script from "./GroupsList.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsList.vue?vue&type=script&setup=true&lang=js"

import "./GroupsList.vue?vue&type=style&index=0&id=768f2da8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768f2da8"]])

export default __exports__